import PropTypes from 'prop-types';

const actionType = PropTypes.shape({
  type: PropTypes.oneOf(['divider', 'submenu']),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.func,
  ]),
  onClick: PropTypes.func,
  disabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  dataTestId: PropTypes.string,
  submenuActions: PropTypes.any,
  popupClassName: PropTypes.string,
  popupOffset: PropTypes.arrayOf(PropTypes.number),
  alignSubmenuWithParentMenu: PropTypes.bool,
  useAiActionsMenu: PropTypes.bool,
  parentMenuSelector: PropTypes.string,
  dividerBefore: PropTypes.bool,
  dividerAfter: PropTypes.bool,
});

export const actionShape = PropTypes.arrayOf(actionType);

export const groupedActionShape = PropTypes.arrayOf(
  PropTypes.shape({
    label: PropTypes.element,
    actions: PropTypes.arrayOf(
      PropTypes.shape({
        className: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
        icon: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
        text: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.element,
          PropTypes.func,
        ]),
        onClick: PropTypes.func,
        disabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
        popOverContent: PropTypes.element,
        dataTestId: PropTypes.string,
      }),
    ),
  }),
);
